import React from "react";
import { View, Text } from "react-native";

const CEO = () => {
  return (
    <View>
      <Text>CEO</Text>
    </View>
  );
};

export default CEO;
